import { render, staticRenderFns } from "./ModalMovie.vue?vue&type=template&id=1abeefc1&scoped=true&lang=pug&"
import script from "./ModalMovie.vue?vue&type=script&lang=js&"
export * from "./ModalMovie.vue?vue&type=script&lang=js&"
import style0 from "./ModalMovie.vue?vue&type=style&index=0&id=1abeefc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abeefc1",
  null
  
)

export default component.exports